import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { CustomsError } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminEditCustomsError = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (customsErrorData: Partial<CustomsError>) => {
      return apiClient.customsError.editCustomsError.mutation({ params: { id: customsErrorData._id }, body: customsErrorData });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-customs-errors-list'] });
      toast.success('Customs error updated successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating customs error!');
    },
  });
};
